/**
 * Engine color identities — every intelligence engine + strategy gets a
 * distinct accent so users learn to associate the color with the module.
 *
 * Consumed by:
 *   - ModuleStub — icon halo + eyebrow color
 *   - Dashboard tiles — accent stripe & icon
 *   - Sidebar (future) — colored dot on the leaf
 *
 * Kept in one place so a single edit cascades everywhere.
 */

// Tailwind palette anchors:  bg-*-500, ring-*-200, text-*-700 …
// (all colors are named so we can compose classes at call sites)
export const ENGINE_COLORS = {
  gold:   { name: "gold",   hex: "#F59E0B", grad: "from-amber-400 to-amber-600",
            iconBg: "bg-amber-50",   iconRing: "ring-amber-200",  iconText: "text-amber-600",
            chipBg: "bg-amber-500/10",  chipText: "text-amber-700",  chipRing: "ring-amber-500/30",
            accent: "bg-amber-500", eyebrow: "text-amber-600" },
  green:  { name: "green",  hex: "#10B981", grad: "from-emerald-400 to-emerald-600",
            iconBg: "bg-emerald-50", iconRing: "ring-emerald-200", iconText: "text-emerald-600",
            chipBg: "bg-emerald-500/10", chipText: "text-emerald-700", chipRing: "ring-emerald-500/30",
            accent: "bg-emerald-500", eyebrow: "text-emerald-600" },
  blue:   { name: "blue",   hex: "#3B82F6", grad: "from-sky-400 to-blue-600",
            iconBg: "bg-blue-50",    iconRing: "ring-blue-200",    iconText: "text-blue-600",
            chipBg: "bg-blue-500/10",   chipText: "text-blue-700",   chipRing: "ring-blue-500/30",
            accent: "bg-blue-500",  eyebrow: "text-blue-600" },
  red:    { name: "red",    hex: "#EF4444", grad: "from-rose-400 to-red-600",
            iconBg: "bg-rose-50",    iconRing: "ring-rose-200",    iconText: "text-rose-600",
            chipBg: "bg-rose-500/10",   chipText: "text-rose-700",   chipRing: "ring-rose-500/30",
            accent: "bg-rose-500",  eyebrow: "text-rose-600" },
  purple: { name: "purple", hex: "#8B5CF6", grad: "from-violet-400 to-purple-600",
            iconBg: "bg-violet-50",  iconRing: "ring-violet-200",  iconText: "text-violet-600",
            chipBg: "bg-violet-500/10", chipText: "text-violet-700", chipRing: "ring-violet-500/30",
            accent: "bg-violet-500", eyebrow: "text-violet-600" },
  slate:  { name: "slate",  hex: "#64748B", grad: "from-slate-400 to-slate-600",
            iconBg: "bg-slate-50",   iconRing: "ring-slate-200",   iconText: "text-slate-600",
            chipBg: "bg-slate-500/10",  chipText: "text-slate-700",  chipRing: "ring-slate-500/30",
            accent: "bg-slate-500", eyebrow: "text-slate-600" },
};

// Map every module → color
export const MODULE_THEME = {
  // Intelligence Engines
  "wholesale-engine":   ENGINE_COLORS.gold,
  "repair":             ENGINE_COLORS.green,
  "comps-arv":          ENGINE_COLORS.blue,
  "deal-score":         ENGINE_COLORS.red,
  "ai-recommendations": ENGINE_COLORS.purple,
  // Strategy Center — echo the engine that dominates each strategy
  "wholesale":          ENGINE_COLORS.gold,
  "fix-flip":           ENGINE_COLORS.green,
  "brrrr":              ENGINE_COLORS.blue,
  "creative-finance":   ENGINE_COLORS.purple,
};

export function themeFor(slug) {
  return MODULE_THEME[slug] || ENGINE_COLORS.slate;
}
